<aside
  [ngClass]="{ 'w-[240px]': isExpanded, 'w-20': !isExpanded }"
  class="border-standard-divider transition-width sticky top-0 flex max-h-screen flex-col border-r-1 pr-2 duration-50 ease-in-out">
  <div class="sticky top-0 z-10 bg-white">
    <div
      [ngClass]="{
        'flex-col': !isExpanded,
        'mx-sidebar-image-separation flex-row': isExpanded,
      }"
      class="mt-5 flex items-center justify-between">
      @if (isExpanded) {
        <img
          src="images/amcon-logo.svg"
          alt="Amcon Logo"
          [attr.data-testid]="'company-logo-image'" />
      }

      @if (!isExpanded) {
        <button
          (click)="toggleSidebar()"
          class="mt-2 ml-3 h-12 w-12 p-2 focus:outline-hidden"
          type="button">
          <span class="text-standard-icon material-symbols-rounded text-2xl">
            {{ showCollapseIcon() }}
          </span>
        </button>
      }

      <span
        [ngClass]="{
          'bg-yellow-400 text-black': stage === 'TEST',
          'bg-blue-400': stage === 'RC',
          'bg-red-600': stage === 'PROD',
          'bg-blue-100': stage === 'DEV',
          'ml-2': isExpanded,
          'mx-3 mt-2': !isExpanded,
        }"
        class="rounded-xl border-1 px-1 py-1 text-center text-white">
        {{ stage }}
      </span>

      @if (isExpanded) {
        <button
          (click)="toggleSidebar()"
          class="right-0 h-12 w-12 p-2 focus:outline-hidden"
          type="button">
          <span class="text-standard-icon material-symbols-rounded text-2xl">
            {{ showCollapseIcon() }}
          </span>
        </button>
      }
    </div>
  </div>

  <div
    class="mt-sidebar-image-separation overflow-x-hidden overflow-y-auto"
    style="scrollbar-gutter: stable">
    <nav
      [ngClass]="{ 'mr-4 ml-6': isExpanded }"
      class="flex-1"
      role="navigation">
      <ul class="flex flex-col">
        @for (menuTab of sidebarItems.tabs; track $index) {
          @if (isExpanded && menuTab.heading === "BUTTONGROUP") {
            @if (licenseStore.isAnyWebAndAppLicenseActive()) {
              <li class="mb-3 w-full">
                <hr class="border-standard-divider mb-3 border-t-1" />

                <aw-button-group
                  id="configuration-channel"
                  [options]="channelOptions"
                  [compact]="true"
                  ariaLabel="Ausgabekanal"
                  [ngModel]="selectedChannel()"
                  [ngModelOptions]="{ standalone: true }"
                  (ngModelChange)="selectChannel($event)" />
              </li>
            }
          } @else {
            <li
              [ngClass]="{
              'mt-auto mb-5': isLastItem($index),
              'mb-8': !isLastItem($index),
              'flex justify-center': !isExpanded,
            }">
              <aw-menu-tab
                [isExpanded]="isExpanded"
                [menuTab]="menuTab"></aw-menu-tab>
            </li>
          }
        }
      </ul>
    </nav>
  </div>
</aside>
